module.exports = __webpack_public_path__ + "static/media/doc-2.6d8c7083.jpg";